
<template>
  <div>
    <v-bottom-sheet v-model="sheet">
      <v-card>
        <v-card-title>
          <div>
            <div>Oferecimento</div>
          </div>
          <v-spacer></v-spacer>
          <v-btn small icon @click="showSponsors()">
            <v-icon>mdi-more</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-layout row justify-space-around>
            <v-flex xs6 md6 sm6 lg6>
              <v-img v-if="premium">
                <v-img contain max-height="150" :src="premium" alt="alt" />
              </v-img>
            </v-flex>
            <v-flex xs4 md4 sm4 lg4>
              <v-layout>
                <v-img contain max-height="75" :src="ultimate1" alt="alt" />
              </v-layout>
              <v-layout>
                <v-img contain max-height="75" :src="ultimate2" alt="alt" />
              </v-layout>
            </v-flex>
          </v-layout>

          <grid-sponsor v-if="sponsors"></grid-sponsor>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
    <v-btn small fab fixed bottom right color="grey lighten-1" @click="sheet=true">
      <v-icon small dark color="white">fa-handshake</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import logoFusion from "./img/fusionlogo.png";
import logoCkb from "./img/ckblogo.png";
import logoSoco from "./img/socologo.png";

export default {
  components: {
    GridSponsor: () => import("@/components/Championships/Sponsor/Grid.vue")
  },
  data() {
    return {
      bar: true,
      sponsors: false,
      sheet: true,
      premium: logoFusion,
      ultimate1: logoCkb,
      ultimate2: logoSoco
    };
  },
  methods: {
    showSponsors() {
      this.sponsors = !this.sponsors;
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {},
  watch: {
    sheet(nv, ov) {
      if (nv == false) {
        this.sponsors = false;
      }
    }
  }
};
</script>

<style scoped>
</style>